import AnvatoPlayer from '../anvato-player';
import BobPixel from '../bob-pixel';

/**
 * A component responsible for maintaining a single AnvatoPlayer instance for
 * each given Anvato player's ID.
 */
export default class AnvatoPlayerManager {
  /**
   * AnvatoPlayer instances keyed by their Anvato player (not video) ID.
   *
   * @type {Object}
   */
  ids = {};

  /**
   * Constructor.
   *
   * @param {Object} anvp Global Anvato player manager.
   * @param {Object} pageAttributes Theme page attributes.
   * @param {string} bobBaseHost Base host for BOB tag.
   */
  constructor(anvp, pageAttributes, bobBaseHost) {
    this.anvp = anvp;
    this.pageAttributes = pageAttributes;
    this.bobBaseHost = bobBaseHost;

    this.setUpVideo = this.setUpVideo.bind(this);
  }

  /**
   * Pass all videos in the Anvato manager to setUpVideo().
   */
  getAndSetUpAll() {
    if (this.anvp.getAll) {
      this.anvp.getAll().forEach((id) => this.setUpVideo(id));
    }
  }

  /**
   * Instantiate an AnvatoPlayer for a player ID.
   *
   * @param {String} id Anvato player ID.
   */
  setUpVideo(id) {
    if (this.ids[id]) {
      return;
    }

    this.ids[id] = new AnvatoPlayer(
      this.anvp[id],
      // This ID is random.
      new BobPixel(document.body, `bob_anvp_${id}`, null, this.bobBaseHost),
      this.pageAttributes,
    );
  }
}
